module.exports = __webpack_public_path__ + "static/linkedlist-2.5-27a46ec533fc1d4bbb7fc29afb9beff2.png";